import jsCookie from "js-cookie"
import type { NextApiRequest } from 'next'
import { supportLanguage } from 'config/i18nConfig'
import func from "./assemble/func"
import tools from "./assemble/tools"

//判断是否node环境
export const isNode = () => {
  return typeof window === "undefined"
}

/**
 * 通过URL返回参数集合对象或参数值
 * @param {String} sUrl   url
 * @param {[String]} sKey   参数key, 传了返回value, 不传返回参数集合对象
 * @returns {Object | String} { a: '', b: ''} | ''
 */
export const getUrlParam = function (sUrl: string, sKey?: string) {
  const result: any = {}
  sUrl.replace(/\??(\w+)=([\w.\-+]+)&?/g, (a, k, v) => {
    if (result[k] !== void 0) {
      const t = result[k]
      result[k] = [].concat(t, v)
    } else {
      result[k] = v
    }
    return ''
  })
  if (sKey === void 0) {
    return result
  } else {
    return result[sKey] || ""
  }
}


/**
 * @Date: 2022-10-12 16:34:35
 * @method: 根据请求返回词条语言
 * @param {string} path 请求路径  /en/track
 * @param {NextApiRequest} req   请求体
 * @return {sting} lang 语言
 * @return {boolean} isI18n 链接中是否包含语言
 * @Author: wzt
 */
export const getLocalLang = (path: string, req?:NextApiRequest): { lang: string, isI18n: boolean } => {
  const pathArr: Array<string> = path.split('/').filter((item: string) => item)
  const firstPath: string = pathArr && pathArr.length ? pathArr[0] : ''
  const isI18n: boolean = supportLanguage.indexOf(firstPath) !== -1
  const v5_Culture = req ? req.cookies.v5_Culture : jsCookie.get('v5_Culture')
  const lang = isI18n ? firstPath : v5_Culture || 'en'
  return {
    lang,
    isI18n
  }
}


export default {
  func,
  tools
}